import { render, staticRenderFns } from "./addMedal.vue?vue&type=template&id=5ec14ef1&scoped=true"
import script from "./addMedal.vue?vue&type=script&lang=js"
export * from "./addMedal.vue?vue&type=script&lang=js"
import style0 from "./addMedal.vue?vue&type=style&index=0&id=5ec14ef1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec14ef1",
  null
  
)

export default component.exports